<bs-page-menu-template>
    <bs-side-menu-item [id]="dashboardMenuItem.id" [icon]="dashboardMenuItem.icon"
        [label]="dashboardMenuItem.label | translate" [url]="dashboardMenuItem.url"
        [exactPath]="dashboardMenuItem.exactPath" />
    <bs-side-menu-item [id]="myTiresMenuItem.id" [icon]="myTiresMenuItem.icon"
        [label]="myTiresMenuItem.label | translate" [url]="myTiresMenuItem.url"
        [exactPath]="myTiresMenuItem.exactPath" />
    <bs-side-menu-item [id]="myBatchesMenuItem.id" [icon]="myBatchesMenuItem.icon"
        [label]="myBatchesMenuItem.label | translate" [url]="myBatchesMenuItem.url"
        [exactPath]="myBatchesMenuItem.exactPath" />
    <bs-side-menu-item [id]="damageReportsMenuItem.id" [counters]="damageReportsMenuItem.counters ?? []"
        [icon]="damageReportsMenuItem.icon" [label]="damageReportsMenuItem.label | translate"
        [url]="damageReportsMenuItem.url" [exactPath]="damageReportsMenuItem.exactPath" />

    @if (currentCustomer$()?.managedByBBj) {
    <bs-side-menu-item [id]="rejectedTiresMenuItem.id" [counters]="rejectedTiresMenuItem.counters ?? []"
        [icon]="rejectedTiresMenuItem.icon" [label]="rejectedTiresMenuItem.label | translate"
        [url]="rejectedTiresMenuItem.url" [exactPath]="rejectedTiresMenuItem.exactPath" />
    } @if (currentCustomer$()?.managedByBBj) {
    <bs-side-menu-item [id]="anomalyTires.id" [counters]="anomalyTires.counters ?? []" [icon]="anomalyTires.icon"
        [label]="anomalyTires.label | translate" [url]="anomalyTires.url" [exactPath]="anomalyTires.exactPath" />
    } @if (modeMenuItems$().length) {
    <div class="menu-divider"></div>
    @for (item of modeMenuItems$(); track item.id) {
    <bs-side-menu-item [id]="item.id" [icon]="item.icon" [counters]="item.counters ?? []"
        [label]="item.label | translate" [exactPath]="item.exactPath" [url]="item.url" />
    }
    }

    <!-- ------------------------------------------------- DEV ENVIRONMENT ONLY------------------------------------------------------- -->
    @if (!isProduction) {
    <div class="menu-divider"></div>

    <bs-side-menu-item [id]="resetDataMenuItem.id" [icon]="resetDataMenuItem.icon"
        [label]="resetDataMenuItem.label | translate" (click)="handleResetDataMenuClick()" />
    <bs-side-menu-item [id]="newContainerMenuItem.id" [icon]="newContainerMenuItem.icon"
        [label]="newContainerMenuItem.label | translate" (click)="handleAddNewContainer()" />
    <bs-side-menu-item [id]="newPreparationMenuItem.id" [icon]="newPreparationMenuItem.icon"
        [label]="newPreparationMenuItem.label | translate" (click)="handleAddNewPreparation()" />
    <bs-side-menu-item [id]="newNotificationMenuItem.id" [icon]="newNotificationMenuItem.icon"
        [label]="newNotificationMenuItem.label | translate" (click)="handleAddNewNotification()" />
    }

</bs-page-menu-template>